import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFetchWithSpinner } from "../../hooks/useFetchWithSpinner";
import CapturasView from "./CapturasView";
//import IncautacionArmasView from "./IncautacionArmasView";
import EstupefacientesView from "./EstupefacientesView";
import RecuperacionAutomotoresView from "./RecuperacionAutomotoresView";
import { selectDates, selectTopN, selectComparisonYear } from "../../redux/slices/filtersSlice";
import { applyFilterLogic } from "../../utils/filterFunctions";
import "./Pages.css";

const Operatividad = () => {
  const [activeTab, setActiveTab] = useState("capturas");

  // Obtener filtros globales desde Redux
  const dates = useSelector(selectDates);
  const comparisonYear = useSelector(selectComparisonYear);
  const topN = useSelector(selectTopN);

  const [filters, setFilters] = useState({});
  const [frozenKey, setFrozenKey] = useState(null);
  const [filtersaux, setFiltersaux] = useState({});
  const [frozenKeyaux, setFrozenKeyaux] = useState(null);
  const [data, setData] = useState([]);
  const fetchWithSpinner = useFetchWithSpinner();

  const tabs = [
    { key: "capturas", label: "Capturas", endpoint: "capturas" },
    //{ key: "armas", label: "Incautación de Armas", endpoint: "incautacionArmas" },
    { key: "estupefacientes", label: "Estupefacientes", endpoint: "estupefacientes" },
    { key: "automotores", label: "Recuperación Automotores", endpoint: "recuperacionAutomotores" },
  ];

  const handleFilterClick = (tipo, valor, source, nameFilter = "otros") => {
    if (nameFilter === "motos") setFiltersaux((prevFilters) =>
      applyFilterLogic(prevFilters, tipo, valor, source, frozenKeyaux, setFrozenKeyaux, {})
    );
    else setFilters((prevFilters) =>
      applyFilterLogic(prevFilters, tipo, valor, source, frozenKey, setFrozenKey, {})
    );
  };

  useEffect(() => {
    setFilters({});
    setFrozenKey(null);
    setFiltersaux({});
    setFrozenKeyaux(null);
    setData([]);
  }, [activeTab]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "capturas":
        return <CapturasView filters={filters} frozenKey={frozenKey} dates={dates} handleFilterClick={handleFilterClick} topN={topN} fetchWithSpinner={fetchWithSpinner} data={data} setData={setData} comparisonYear={comparisonYear} />;
      /*case "armas":
        return <IncautacionArmasView filters={filters} frozenKey={frozenKey} dates={dates} handleFilterClick={handleFilterClick} topN={topN} fetchWithSpinner={fetchWithSpinner} data={data} setData={setData} />;*/
      case "estupefacientes":
        return <EstupefacientesView filters={filters} frozenKey={frozenKey} dates={dates} handleFilterClick={handleFilterClick} topN={topN} fetchWithSpinner={fetchWithSpinner} data={data} setData={setData} comparisonYear={comparisonYear} />;
      case "automotores":
        return <RecuperacionAutomotoresView filters={filters} frozenKey={frozenKey} filtersaux={filtersaux} frozenKeyaux={frozenKeyaux} dates={dates} handleFilterClick={handleFilterClick} topN={topN} fetchWithSpinner={fetchWithSpinner} data={data} setData={setData} comparisonYear={comparisonYear} />;
      default:
        return null;
    }
  };

  return (
    <div className="dashboard-container">
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-button ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {renderActiveTab()}

    </div>
  );
};

export default Operatividad;
